import React, { type ReactNode, useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, type StripeElementsOptions } from '@stripe/stripe-js'
import { useTranslation } from 'react-i18next'

function StripeWrapper({
	accountId,
	clientSecret,
	children,
}: {
	accountId: string
	clientSecret: string
	children: ReactNode
}) {
	const [stripePromise, setStripePromise] = useState(null)

	const { i18n } = useTranslation()
	const stripeLocale = i18n.language.startsWith('fr') ? 'fr-CA' : 'en'

	// This function will re-run if the accountId prop changes.
	useEffect(() => {
		const fetchStripePromise = async () => {
			// If there is no accountId, do not run the loadStripe function.
			if (accountId) {
				const stripePromise = await loadStripe(ENV.STRIPE_PUBLISHABLE_KEY ?? '', {
					stripeAccount: accountId,
				})
				// When we have got the Stripe object, pass it into our useState.
				// @ts-ignore
				setStripePromise(stripePromise)
			}
		}
		fetchStripePromise()
	}, [accountId])

	// If no Stripe object, do not render the Stripe Element.
	if (!stripePromise) {
		return <p>Loading...</p>
	}

	const options: StripeElementsOptions = {
		clientSecret: clientSecret,
		appearance: {
			theme: 'stripe',
		},
		locale: stripeLocale,
	}

	// Once we have the Stripe object, load everything.
	return (
		<Elements stripe={stripePromise} options={options}>
			{children}
		</Elements>
	)
}

export default StripeWrapper
